import React from 'react';
import MealSlotAddButton from './MealSlotAddButton';

/**
 * Options-first layout: one row per meal type for the selected option.
 * The slot editor renders its own row (summary card + recipes) so the card can
 * drive slot-level edits like the intake time; `summary` carries the card data.
 */
export default function MealSlotOptionsFirstRows({
  mealTypes = [],
  getRowMeta,
  renderSlotEditor,
  onAddClick,
  addButtonTitle = 'Add meal type',
  showAddButton = true,
}) {
  return (
    <div className="space-y-0">
      {mealTypes.map((mealType) => {
        const { itemCount, caloriesLabel, macros } = getRowMeta(mealType);
        return (
          <React.Fragment key={mealType}>
            {renderSlotEditor(mealType, {
              title: mealType,
              itemCount,
              caloriesLabel,
              macros,
            })}
          </React.Fragment>
        );
      })}
      {showAddButton && onAddClick && (
        <MealSlotAddButton onClick={onAddClick} title={addButtonTitle} />
      )}
    </div>
  );
}
